# frozen_string_literal: true

module Engine
  class GameError < RuntimeError
  end

  # problem with the structure of the Engine::Action object or the hash being
  # used to create it
  class ActionError < GameError
  end

  class GameIsOver < GameError
  end

  # errors generated by route.revenue and used by auto_router

  class NoToken < GameError
  end

  class RouteTooShort < GameError
  end

  class RouteTooLong < GameError
  end

  class ReusesCity < GameError
  end
end
